import 'virtual:svg-icons-register'
if (/^\/(market|s|my\/desktops)(\/|$)/.test(location.pathname)) {
  import('./market-main')
} else {
  Promise.all([import('@atom/desktop/client/mount'), import('./host/desktop')]).then(
    ([{ mountDesktop }, { desktopHost }]) => mountDesktop('#app', desktopHost),
  )
}
